import * as idEndpoints from './id';
import { root } from './video';

export const video = {
  ...root,
  id: {
    ...idEndpoints.id,
  },
};
